import * as React from "react";
import Box from "@mui/material/Box";
import { Button, Grid, Typography } from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import update from "immutability-helper";
import { toast } from "react-toastify";
import { useStyles } from "./parent-dashboard";
import { useState, useEffect } from "react";
import { API_EPICENTER } from "../../services/api-services";
import { Spinner } from "react-bootstrap";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import { ArrowBack } from "@material-ui/icons";
import { postToNative } from "../EditClass/services/utils/nativeBridge";

const handleQuite = () => {
  postToNative({ type: "route", url: "Help" });
};

export default function RaiseRequestModal({ open, handleClose, data }) {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    studentId: "",
    courseCategory: "",
    studentIssue: "",
    details: "",
  });
  const [errorLog, setErrorLog] = useState(false);
  const [submitError, setSubmitError] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [countdown, setCountdown] = useState(3);

  const courses = ["Coding", "Math", "Science", "English"];
  const category = [
    "I wish to change my regular schedule for classes.",
    "I want to provide feedback for my mentor Please provide student progress report (SPR).",
    "Please arrange parent teacher meeting (PTM).",
    "I've not received my referral bonus even after 45 days of referee enrolling.",
    "I'm facing technical issue.",
    "Upgrade my course from group to 1-on-1.",
    "Please change my mentor",
    "I wish to speak with Codeyoung representative",
  ];

  const itemList = localStorage.getItem("studentsList");
  const studentList = JSON.parse(itemList);

  // Countdown effect for success screen
  useEffect(() => {
    if (showSuccess && countdown > 0) {
      const timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
      return () => clearTimeout(timer);
    } else if (showSuccess && countdown === 0) {
      if (window.ReactNativeWebView) {
        postToNative({ type: "route", url: "Help" });
      } else {
        handleClose ? handleClose() : handleQuite();
      }
    }
  }, [showSuccess, countdown, handleClose]);

  const onChangeHandler = (e, type) => {
    setSubmitError(false);
    setErrorLog(false);
    switch (type) {
      case "student":
        const updatedLeadName = update(formData, {
          studentId: { $set: e.target.value },
        });
        return setFormData(updatedLeadName);
      case "course":
        const updateCourse = update(formData, {
          courseCategory: { $set: e.target.value },
        });
        return setFormData(updateCourse);
      case "category":
        const updateCategory = update(formData, {
          studentIssue: { $set: e.target.value },
        });
        return setFormData(updateCategory);
      case "other":
        const updateotherDetails = update(formData, {
          details: { $set: e.target.value },
        });
        return setFormData(updateotherDetails);
      default:
        return;
    }
  };

  const handleSave = () => {
    setSubmitError(false);
    setErrorLog(false);
    if (
      formData.studentId === "" ||
      formData.courseCategory === "" ||
      formData.studentIssue === "" ||
      formData.details === ""
    ) {
      return setErrorLog(true);
    }
    setLoading(true);
    API_EPICENTER.post("/ticketGeneration", {
      studentId: formData.studentId,
      text: formData.details,
      courseCategory: formData.courseCategory,
      studentIssue: formData.studentIssue,
    })
      .then((res) => {
        setLoading(false);
        setSubmitError(false);
        setShowSuccess(true);
      })
      .catch((e) => {
        toast.error(e?.response?.data?.msg, {
          position: toast.POSITION.TOP_CENTER,
        });
        setLoading(false);
        setSubmitError(true);
        console.error("Error while saving details", e);
      });
  };

  if (showSuccess) {
    return (
      <React.Fragment>
        <Box
          style={{
            padding: "32px 16px",
            textAlign: "center",
            minHeight: "400px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "99.5vh",
          }}
        >
          <div
            style={{
              width: "60px",
              height: "60px",
              borderRadius: "50%",
              backgroundColor: "#4CAF50",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: "24px",
            }}
          >
            <span
              style={{
                color: "white",
                fontSize: "30px",
                fontWeight: "bold",
              }}
            >
              ✓
            </span>
          </div>
          <Typography
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#333",
              marginBottom: "16px",
              fontFamily: "Inter",
            }}
          >
            Request raised successfully
          </Typography>
          <Typography
            style={{
              fontSize: "14px",
              color: "#999",
              fontFamily: "Inter",
            }}
          >
            Redirecting to dashboard in {countdown} seconds...
          </Typography>
        </Box>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <Box style={{ padding: "32px 16px", height: "100vh" }}>
        {/* <Box
          style={{
            width: "110px",
            borderRadius: "24px",
            display: "flex",
            alignItems: "center",
            marginBottom: "24px",
            gap: "4px",
          }}
          onClick={() => {
            handleClose ? handleClose() : handleQuite();
          }}
        >
          <ArrowBack
            style={{
              fontSize: "16px",
              color: "#808080",
              fontWeight: "700",
            }}
          />
          <Typography
            style={{
              fontSize: "14px",
              color: "#808080",
              fontWeight: "700",
            }}
          >
            Go back
          </Typography>
        </Box> */}
        <h1 className={classes.heading}>Raise Request</h1>
        <p className={classes.subHeading}>
          Please provide detailed information below. We would like to serve you
          better.
        </p>
        {/* <DialogContent> */}
        <Box
          style={{ minHeight: "319px", gap: "16px", marginBottom: "16px" }}
          className={`${classes.flex_col} ${classes.alignContentCenter} ${classes.justifyAround} ${classes.width100}`}
        >
          <TextField
            SelectProps={{
              MenuProps: {
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "left",
                },
                getContentAnchorEl: null,
                PaperProps: {
                  style: {
                    maxHeight: "360px",
                  },
                },
              },
            }}
            select
            variant="outlined"
            onChange={(e) => onChangeHandler(e, "student")}
            value={formData.studentId}
            fullWidth
            size="large"
            className={classes.inputField}
            label="Select Student"
            required
          >
            {studentList &&
              studentList.map((student, index) => {
                return (
                  <MenuItem key={index} value={student.studentId}>
                    {student.studentName}
                  </MenuItem>
                );
              })}
          </TextField>
          <TextField
            SelectProps={{
              MenuProps: {
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "left",
                },
                getContentAnchorEl: null,
                PaperProps: {
                  style: {
                    maxHeight: "360px",
                  },
                },
              },
            }}
            select
            variant="outlined"
            onChange={(e) => onChangeHandler(e, "course")}
            value={formData.courseCategory}
            fullWidth
            size="large"
            className={`${classes.inputField} ${classes.width100}`}
            label="Select Course"
            required
          >
            {courses?.map((course, index) => {
              return (
                <MenuItem key={index} value={course}>
                  {course}
                </MenuItem>
              );
            })}
          </TextField>
          <TextField
            SelectProps={{
              MenuProps: {
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "left",
                },
                getContentAnchorEl: null,
                PaperProps: {
                  style: {
                    maxHeight: "360px",
                    maxWidth: "260px",
                  },
                },
              },
            }}
            select
            variant="outlined"
            onChange={(e) => onChangeHandler(e, "category")}
            value={formData.studentIssue}
            fullWidth
            size="large"
            className={classes.inputField}
            label="Select Category"
          >
            {category.map((dataa, index) => {
              return (
                <MenuItem
                  key={index}
                  value={dataa}
                  style={{ whiteSpace: "pre-line" }}
                >
                  {dataa}
                </MenuItem>
              );
            })}
          </TextField>
          <TextareaAutosize
            rowsMax={10}
            value={formData.details}
            className={classes.width100}
            onChange={(e) => onChangeHandler(e, "other")}
            fullWidth
            style={{
              minHeight: 90,
              border: "2px solid #E6E6E6",
              borderRadius: "16px",
              padding: "16px",
              color: "#333",
              background: "#fff",
              fontFamily: "inherit",
              fontSize: "inherit",
              outline: "none",
              resize: "vertical",
            }}
            placeholder="Enter your request details here"
          />
        </Box>
        <Box
          style={{ padding: "0px", marginTop: "32px" }}
          className={`${classes.flex_row} ${classes.justifyCenter} ${classes.width100} pb-1`}
        >
          <Button
            disabled={loading}
            className={classes.submitBtn}
            onClick={handleSave}
          >
            {loading ? (
              <Spinner animation="border" variant="grey" />
            ) : (
              "Submit feedback"
            )}
          </Button>
        </Box>
        {/* </DialogActions> */}
        {errorLog ? (
          <Grid
            style={{
              color: "red",
              fontWeight: "bold",
              textAlign: "center",
              paddingBottom: "15px",
            }}
          >
            Please fill all required details
          </Grid>
        ) : submitError ? (
          <Grid
            style={{
              color: "red",
              fontWeight: "bold",
              textAlign: "center",
              marginTop: "10px",
              paddingBottom: "15px",
            }}
          >
            Sorry! something went Wrong <br />
            Please try again in some time
          </Grid>
        ) : (
          <Grid></Grid>
        )}
        {/* </Dialog> */}
      </Box>
    </React.Fragment>
  );
}
